/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-useless-path-segments */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable no-plusplus */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect, useRef } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import {
  MdAccountCircle,
  MdKeyboardArrowDown,
  MdOutlineArrowBack,
  MdOutlineCreditCard,
} from 'react-icons/md';
import { CiWallet, CiBank } from 'react-icons/ci';
import { IoMdEye, IoMdEyeOff } from 'react-icons/io';
import { useLocation, useNavigate } from 'react-router-dom';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
// import NoSearchResults from '../../one-way/NoSearchResults';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import './BusBookingReview.scss';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import {
  BUS_PAX,
  DATE_MONTH_YEAR_VIEW_FORMAT,
  DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
  NAVIGATION_ROUTES,
  // ONLY_TIME_FORMAT,
  ONLY_DATE_MONTH_FORMAT,
} from '../../../shared/constants/Constants';
import {
  convertTravelTime,
  formatCurrency,
  formatDate,
  formatTimeString,
  getEligibilityForPaymentMode,
  getEligibilityForPgOptions,
  getNewDate,
  hideHeaderFooterInMobile,
  isEmpty,
  isMobileWidth,
  showHeaderFooterInMobile,
} from '../../../shared/helper-utils/appUtils';
import {
  bookBusApi,
  getBusFareApi,
  getProfileForNameApi,
} from '../../../api/busApi';
import {
  getObjectFromLS,
  getUserAgentId,
  getValueFromAppConfig,
} from '../../../shared/helper-utils/localStorage';
import AppModal from '../../../shared/components/app-modal/AppModal';
import AppNumberInput from '../../../shared/components/app-number-input/AppNumberInput';
import AppLink from '../../../shared/components/app-link/AppLink';
import AppRadioInput from '../../../shared/components/app-radio-input/AppRadioInput';
import AppCheckBox from '../../../shared/components/app-check-box/AppCheckBox';
import BusCancellationPolicy from '../../buses/search-results/BusCancellationPolicy';
import {
  NET_BANKING_OPTIONS,
  NET_BANKING_OPTIONS_LIVE,
  PAYU_BANKING_OPTIONS,
  PAYU_BANKING_OPTIONS_LIVE,
} from '../../../shared/constants/NetBankingOptions';
import AppIconButton from '../../../shared/components/app-icon-button/AppIconButton';
import PaymentGatewayApii from '../../hotels/booking-review/PaymentGatewayApii';
import {
  addMarkupInTicket,
  getPGCheckOutAmountApi,
} from '../../../api/flightApi';
import AppSidebar from '../../../shared/components/app-sidebar/AppSidebar';
import BusPaxBottomSheet from './BusPaxBottomSheet';
import { getUserDetails } from '../../../api/profileApi';
import { APP_USER_PROFILE } from '../../../saas/AppStorageStaticNames';

const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const NAME_REGEX = /^[a-zA-Z ]*$/;

const TITLE_OPTIONS = [
  { label: 'Mr', value: 'Mr' },
  { label: 'Ms', value: 'Ms' },
  { label: 'Mrs', value: 'Mrs' },
  { label: 'Mstr', value: 'Mstr' },
];

const GENDER_OPTIONS = [
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
  { label: 'Others', value: 'Others' },
];

function GetBookingDetailsLabel({ label }) {
  return (
    <Col lg={2} md={4} sm={4} xs={4}>
      <span className="booking-details-label">{label}</span>
    </Col>
  );
}

function GetBookingDetailsValue({ value }) {
  return (
    <Col lg={4} md={8} sm={8} xs={8}>
      <span className="booking-details-value">{value}</span>
    </Col>
  );
}

function BusBookingReview() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const {
    selectedBus,
    searchRequest,
    selectedSeats,
    boardingPoint,
    droppingPoint,
    seatResponseId,
  } = state;
  const [isLoading, setLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [fareDetails, setFareDetails] = useState({});
  const [isSearchDone, setSearchDone] = useState(false);
  const [contactDetails, setContactDetails] = useState({
    email: '',
    phoneNumber: '',
    firstName: '',
    lastName: '',
    panNumber: '',
    gender: '',
  });
  const [searchText, setSearchText] = useState('');
  const [customers, setCustomers] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [showPassengerSearchModal, setShowPassengerSearchModal] =
    useState(false);
  const [passengers, setPassengers] = useState(
    selectedSeats.map((d) => {
      return {
        ...BUS_PAX,
        seatnumber: d.name,
        seatprice: d.totalnet,
        seattype: d.seattype,
      };
    }),
  );
  const [fareResponse, setFareResponse] = useState(undefined);
  const [isBookingConfirmationDialogOpen, setBookingConfirmationDialogOpen] =
    useState(false);
  const [busRemarks, setBusRemarks] = useState('');
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [isBookingClicked, setIsBookingClicked] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const [hasFreeCancellation, setHasFreeCancellation] = useState(true);
  const [paymentMode, setPaymentMode] = useState('');
  const [showCanxPolicies, setShowCanxPolicies] = useState(false);
  const [appliedMarkup, setAppliedMarkup] = useState('');
  const [addedMarkup, setAddedMarkup] = useState('');
  const [selectedBankForNetBanking, setSelectedBankForNetBanking] =
    useState('');
  const [showNetFare, setShowNetFare] = useState(false);
  const [selectedPg, setSelectedPg] = useState('');
  const [checkoutPgCharge, setcheckoutPgCharge] = useState(0);
  const [checkoutgstPgCharge, setgstcheckoutPgCharge] = useState(0);
  const [checkoutInvTotal, setcheckoutInvTotal] = useState(0);
  const [isMarkupUpdated, setIsMarkupUpdated] = useState(false);
  const [viewFareSummary, setViewFareSummary] = useState(false);
  const [showPaxModal, setShowPaxModal] = useState(false);
  const selectedPaxIndexRef = useRef(undefined);
  const selectedPaxRef = useRef(undefined);
  const [agent, setAgent] = useState({});
  const [isPayuPgAccepted, setIsPayuPgAccepted] = useState(false);

  useEffect(() => {
    hideHeaderFooterInMobile();
    return () => showHeaderFooterInMobile();
  }, []);

  const handleAddMarkup = (d) => {
    setAppliedMarkup(d);
    setIsMarkupUpdated(false);
  };

  const handleMarkupAddition = () => {
    setAddedMarkup(appliedMarkup);
    setIsMarkupUpdated(true);
  };

  const handlePgSelect = (pgName) => {
    setSelectedPg(pgName);
  };

  const getBusFare = async () => {
    setLoading(true);
    const res = await getUserDetails(getUserAgentId());
    if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      if (!isEmpty(User)) {
        setAgent(User);
      }
    }
    const response = await getBusFareApi(
      selectedBus,
      searchRequest,
      selectedSeats,
      seatResponseId,
    );
    if (response.apistatus?.status === 'OK') {
      setFareDetails(response.busfarebreakup || {});
      setFareResponse(response);
      setSearchDone(true);
    } else {
      setAlert({
        variant: 'error',
        title: 'Bus Fare Search',
        description: response.apistatus?.message,
      });
    }
    setLoading(false);
  };

  const handlePaxDetailsChange = (name, value, index) => {
    const list = [...passengers];
    list[index][name] = value;
    if (name === 'title') {
      if (value === 'Mr' || value === 'Mstr') list[index].gender = 'Male';
      else list[index].gender = 'Female';
    }
    setPassengers(list);
  };

  useEffect(() => {
    getBusFare();
  }, []);

  const checkValidMobileNumber = (number) => {
    return number !== '' && /^[5-9]\d{9}$/gi.test(number) === false;
  };

  const checkValidEmailAddress = (email) => {
    return email !== '' && EMAIL_REGEX.test(email) === false;
  };

  const checkValidName = (name) => {
    return NAME_REGEX.test(name) === false;
  };

  const bookABus = async () => {
    setLoading(true);
    const agentId = getUserAgentId();
    const paxList = [...passengers];
    paxList.forEach((pax) => {
      pax.email = contactDetails.email;
    });
    let bankId = '';
    if (
      paymentMode === 'netbanking' &&
      (selectedPg === 'techprocessv2' ||
        selectedPg === 'techprocessv2_netbanking' ||
        selectedPg === 'payu')
    ) {
      bankId = selectedBankForNetBanking;
    }
    const userProfile = getObjectFromLS(APP_USER_PROFILE);
    const request = {
      busfareresponse: fareResponse,
      buspassengers: paxList,
      boardingpoint: boardingPoint,
      droppingpoint: droppingPoint,
      agentid: agentId,
      paymentmode: paymentMode,
      pgname: selectedPg,
      contact_email: contactDetails.email,
      contact_mobile: contactDetails.phoneNumber,
      promocode: '',
      promovalue: '',
      remarks: busRemarks,
      additionalbasefare: '', // addedMarkup === '' ? 0 : parseInt(addedMarkup, 10)
      bankid: bankId,
      bookingkey: fareResponse.bookingkey,
    };
    const response = await bookBusApi(request, agentId);
    const markUpTobeAdded = addedMarkup === '' ? 0 : parseInt(addedMarkup, 10);
    if (response?.wsstatus.status === 'OK') {
      const markupResponse = await addMarkupInTicket(
        userProfile?.agentId,
        response.txid,
        markUpTobeAdded,
      );
      if (markupResponse && markupResponse?.Root?.Status === 'OK') {
        if (paymentMode === 'cashcard') {
          setAlert({
            variant: 'success',
            title: response?.wsstatus?.message || 'Bus Booking Success',
            description:
              'You have successfully booked a ticket, Redirecting to Ticket page...',
          });
          setTimeout(() => {
            navigate(`/bus/print-ticket/${response.txid}`);
          }, 2000);
        } else {
          const { pgurl } = response;
          let urlToRedirect = `${pgurl}`;
          if (paymentMode === 'netbanking') {
            urlToRedirect += `&bankcode=${selectedBankForNetBanking}`;
          }
          window.open(urlToRedirect, '_blank');
        }
      } else {
        setAlert({
          variant: 'error',
          title: 'Addition Markup',
          description: response?.wsstatus?.message,
        });
      }
    } else {
      setAlert({
        variant: 'error',
        title: 'Bus Booking',
        description: response?.wsstatus?.message,
      });
    }
    setLoading(false);
  };

  const payNowButtonClick = async () => {
    if (paymentMode === '') {
      setAlert({
        variant: 'error',
        title: 'Payment Mode',
        description: 'Please select method of payment',
      });
      return false;
    }
    if (paymentMode !== 'cashcard' && selectedPg === 'payu') {
      if (!isPayuPgAccepted) {
        setAlert({
          variant: 'error',
          title: 'Accept Terms',
          description: 'Please Accept terms and conditions of payu',
        });
        return false;
      }
    }
    setIsBookingClicked(true);
    const paxList = [...passengers];
    let isError = false;
    for (let i = 0; i < paxList.length; i++) {
      if (
        paxList[i].title === undefined ||
        paxList[i].firstname === undefined ||
        paxList[i].lastname === undefined ||
        paxList[i].gender === undefined ||
        paxList[i].firstname === undefined ||
        paxList[i].age === '' ||
        paxList[i].lastname === ''
      ) {
        isError = true;
      }
    }
    if (
      contactDetails.phoneNumber === undefined ||
      contactDetails.phoneNumber === '' ||
      /^[5-9]\d{9}$/gi.test(contactDetails.phoneNumber) === false ||
      contactDetails.email === undefined ||
      contactDetails.email === '' ||
      EMAIL_REGEX.test(contactDetails.email) === false
    ) {
      isError = true;
    }
    if (paymentMode === 'netbanking' && selectedBankForNetBanking === '') {
      isError = true;
    }
    if (isError) {
      setValidationError(true);
      return false;
    }
    if (!acceptTerms) {
      isError = true;
      setAlert({
        title: 'Bus Booking',
        description: 'Please accept Terms and Conditions',
        variant: 'error',
      });
    }

    let bankId = '';
    if (
      paymentMode === 'netbanking' &&
      (selectedPg === 'techprocessv2' ||
        selectedPg === 'techprocessv2_netbanking' ||
        selectedPg === 'payu')
    ) {
      bankId = selectedBankForNetBanking;
    }

    const pgcheckoutamount = await getPGCheckOutAmountApi(
      paymentMode,
      selectedPg,
      '',
      fareDetails.farequotetotal,
      'bus',
      getUserAgentId(),
      bankId,
    );
    if (pgcheckoutamount?.ApiStatus?.Status === 'OK') {
      const { Result = {} } = pgcheckoutamount.ApiStatus;
      setcheckoutPgCharge(Result.PgCharges);
      setgstcheckoutPgCharge(Result.GSTOnPgCharges);
      setcheckoutInvTotal(Result.TotalInvoice);
    }
    if (!isError) {
      setBookingConfirmationDialogOpen(true);
    }
  };

  const handleUpdateSearchState = (name, value) => {
    setContactDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    handleUpdateSearchState(name, value);
  };

  // const onPassengerUpdate = (list) => {
  //   setPassengers(list);
  // };

  const onBookingConformationDialogClose = async (shouldProceed) => {
    if (shouldProceed) {
      await bookABus();
    } else {
      setBookingConfirmationDialogOpen(false);
    }
  };

  const getFullName = (item) => {
    let name = '';
    if (item.title) name += item.title;
    if (item.firstname) name += ` ${item.firstname}`;
    if (item.lastname) name += ` ${item.lastname}`;
    return name;
  };

  const handleSearchCustomer = async () => {
    if (searchText !== '') {
      const response = await getProfileForNameApi(searchText, getUserAgentId());
      if (
        response.Root.Status === 'OK' &&
        response.Root.Result.ProfileMasters !== ''
      ) {
        const { ProfileMasters } = response.Root.Result;
        const { ProfileMaster } = ProfileMasters;
        const list = Array.isArray(ProfileMaster)
          ? ProfileMaster
          : [ProfileMaster];
        const firstCustomer = list[0];
        setCustomers(list);
      } else {
        setAlert({
          title: 'Profile Search',
          description: 'No Profiles Found',
          variant: 'error',
        });
      }
    } else {
      setAlert({
        title: 'Profile Search',
        description: 'Please enter name',
        variant: 'error',
      });
    }
  };

  const handleCustomerSelect = (customer) => {
    const list = [...selectedCustomers];
    const index = list.findIndex((x) => x.ProfileId === customers[0].ProfileId);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(customer);
    }
    setSelectedCustomers(list);
  };

  const handleSelectCustomer = () => {
    const firstPax = passengers[0];
    const updatedPax = {
      ...firstPax,
      title: selectedCustomers[0].Title,
      firstname: selectedCustomers[0].FirstName,
      lastname: selectedCustomers[0].LastName,
      gender: selectedCustomers[0].Gender,
      age: selectedCustomers[0].Age,
    };
    const upDatedPaxList = [updatedPax, ...passengers.slice(1)];
    setPassengers(upDatedPaxList);
    setShowPassengerSearchModal(false);
  };

  const onCancelSelectCustomer = () => {
    setSelectedCustomers([]);
    setCustomers([]);
    setSearchText('');
    setShowPassengerSearchModal(false);
  };

  const handleShowPaxDetails = (pax, index) => {
    selectedPaxRef.current = pax;
    selectedPaxIndexRef.current = index;
    setShowPaxModal(true);
  };

  const handleUpdatePaxDetails = (pax, index) => {
    const newPassengers = [...passengers];
    newPassengers[index] = pax;
    setPassengers(newPassengers);
    setShowPaxModal(false);
  };

  return (
    <section className="bus-booking-review-page pb-sm-5 pb-0">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      {isSearchDone && (
        <>
          {!isMobileWidth() ? (
            <div className="bus-booking-review-page_header" />
          ) : (
            <div
              className="modify-search-container show-for-599px"
              // style={{ position: 'sticky', top: '0', zIndex: '10' }}
            >
              <div className="d-flex">
                <AppIconButton
                  onClick={() => navigate(-1)}
                  className="white-color"
                  variant="transparent"
                >
                  <MdOutlineArrowBack />
                </AppIconButton>
                <div className="d-flex justify-content-between p-2 align-items-center flex-1">
                  <div className="fs-14 white-color">
                    <div>
                      {searchRequest.origin.place_name} to{' '}
                      {searchRequest.destination.place_name}
                    </div>
                    <div className="fs-10">
                      {formatDate(
                        getNewDate(searchRequest.jdate),
                        DATE_MONTH_YEAR_VIEW_FORMAT,
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="bus-booking-review-page__body max-width">
            <Row>
              <Col lg={9} md={9} sm={9} xs={12}>
                <div className="bus-booking-review-page__body_bus-details">
                  <div className="pb-2 border-bottom d-flex justify-content-end hide-in-mobile">
                    <AppLink
                      linkText="Back to search results"
                      variant="primary"
                      className="fw-600"
                      onClick={() => navigate(-1)}
                    />
                  </div>
                  <div className="d-flex justify-content-between mb-3">
                    <div className="d-flex flex-column">
                      <span className="fs-18 fw-600">
                        {selectedBus.operatorname}
                      </span>
                      <span className="fs-12 grey-color">
                        {selectedBus.bustype}
                      </span>
                    </div>
                    <div className="d-flex flex-column">
                      <AppLink
                        linkText="View Policies"
                        onClick={() => setShowCanxPolicies(true)}
                        className="fw-600 fs-14"
                      />
                      <span className="fs-12 grey-color">
                        Seat No: {selectedSeats.map((d) => d.name).join(', ')}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <div className="fs-18">
                        <span className="fw-600">
                          {boardingPoint.bdtime
                            ? formatTimeString(boardingPoint.bdtime)
                            : ''}
                        </span>
                        ,{' '}
                        <span className="grey-color">
                          {selectedBus.departuredate
                            ? formatDate(
                                getNewDate(selectedBus.departuredate),
                                ONLY_DATE_MONTH_FORMAT,
                              )
                            : ''}
                        </span>
                      </div>
                      <div className="fs-14 grey-color">
                        {boardingPoint.name}
                      </div>
                    </div>
                    <div className="fs-14 secondary-color p-1 border">{`${convertTravelTime(
                      selectedBus.duration,
                    )}`}</div>
                    <div className="text-end">
                      <div className="fs-18">
                        <span className="fw-600">
                          {droppingPoint.bdtime
                            ? formatTimeString(droppingPoint.bdtime)
                            : ''}
                        </span>
                        ,{' '}
                        <span className="grey-color">
                          {selectedBus.arrivaldate
                            ? formatDate(
                                getNewDate(selectedBus.arrivaldate),
                                ONLY_DATE_MONTH_FORMAT,
                              )
                            : ''}
                        </span>
                      </div>
                      <div className="fs-14 grey-color">
                        {droppingPoint.name}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="separator" />
                <div className="bus-booking-review-page__body_bus-details">
                  <div className="fw-600 fs-18 mb-2">Contact Details </div>
                  <div className="fs-12 fw-300 grey-color mb-2">
                    Your booking details will be sent to this email address and
                    mobile number.
                  </div>
                  <Row className="spacing-8">
                    <Col lg={4} md={4} sm={6} xs={12}>
                      <AppTextInput
                        placeholderText=""
                        label="Email"
                        required
                        value={contactDetails.email}
                        name="email"
                        onChange={handleChange}
                        errorText={
                          validationError &&
                          isBookingClicked &&
                          'Please enter email id'
                        }
                      />
                      {contactDetails?.email?.trim() &&
                        checkValidEmailAddress(contactDetails.email) && (
                          <small className="app-error-text">
                            Please enter valid email id
                          </small>
                        )}
                    </Col>
                    <Col lg={4} md={4} sm={6} xs={12}>
                      <AppTextInput
                        label="Phone Number"
                        placeholderText=""
                        required
                        value={contactDetails.phoneNumber}
                        name="phoneNumber"
                        onChange={handleChange}
                        errorText={
                          validationError &&
                          isBookingClicked &&
                          'Please enter phone number'
                        }
                      />
                      {contactDetails?.phoneNumber?.trim() &&
                        checkValidMobileNumber(contactDetails.phoneNumber) && (
                          <small className="app-error-text">
                            Please enter valid Mobile Number
                          </small>
                        )}
                    </Col>
                  </Row>
                </div>
                <div className="separator" />
                <div className="bus-booking-review-page__body_bus-details">
                  <div className="fw-600 fs-18 mb-2">Passenger Details</div>
                  <div className="fs-12 fw-300 grey-color mb-2">
                    Please add passenger name as shown on Photo ID only
                  </div>
                  <Row className="spacing-8 custom-form">
                    {passengers.map((passenger, index) => (
                      <Col lg={12} key={index}>
                        {!isMobileWidth() ? (
                          <Row className="spacing-8">
                            <Col lg={12}>
                              <span
                                style={{ fontWeight: 500, color: '#666666' }}
                              >{`Pax ${index + 1}`}</span>
                            </Col>
                            <Col lg={2} md={2} sm={4}>
                              <AppSelect
                                label="Title"
                                placeholder=""
                                required
                                className="app-select"
                                name="title"
                                options={TITLE_OPTIONS}
                                selectedValue={passenger.title}
                                onSelect={(data, name) =>
                                  handlePaxDetailsChange(
                                    name,
                                    data.value,
                                    index,
                                  )
                                }
                                isClearable={false}
                                errorText={
                                  validationError &&
                                  isBookingClicked &&
                                  'Please select title'
                                }
                              />
                            </Col>
                            <Col lg={3} md={3} sm={4}>
                              <AppTextInput
                                label="First Name"
                                required
                                value={passenger.firstname}
                                name="firstname"
                                onChange={(e) =>
                                  handlePaxDetailsChange(
                                    e.target.name,
                                    e.target.value,
                                    index,
                                  )
                                }
                                errorText={
                                  validationError &&
                                  isBookingClicked &&
                                  'Please enter First Name'
                                }
                              />
                              {checkValidName(passenger.firstname) && (
                                <small className="app-error-text">
                                  Enter Valid Name
                                </small>
                              )}
                            </Col>
                            <Col lg={3} md={3} sm={4}>
                              <AppTextInput
                                label="Last Name"
                                required
                                value={passenger.lastname}
                                name="lastname"
                                onChange={(e) =>
                                  handlePaxDetailsChange(
                                    e.target.name,
                                    e.target.value,
                                    index,
                                  )
                                }
                                errorText={
                                  validationError &&
                                  isBookingClicked &&
                                  'Please enter Last Name'
                                }
                              />
                              {checkValidName(passenger.lastname) && (
                                <small className="app-error-text">
                                  Enter Valid Name
                                </small>
                              )}
                            </Col>
                            <Col lg={2} md={2} sm={4}>
                              <AppNumberInput
                                label="Age"
                                required
                                value={passenger.age}
                                name="age"
                                onChange={(value) =>
                                  handlePaxDetailsChange('age', value, index)
                                }
                                errorText={
                                  validationError &&
                                  isBookingClicked &&
                                  'Please enter age'
                                }
                              />
                              {passenger.age === 0 && (
                                <small className="app-error-text">
                                  Age should be greater than 0
                                </small>
                              )}
                            </Col>
                            <Col lg={2} md={2} sm={4}>
                              <AppSelect
                                label="Gender"
                                placeholder=""
                                required
                                className="app-select"
                                name="gender"
                                options={GENDER_OPTIONS}
                                selectedValue={passenger.gender}
                                onSelect={(data, name) =>
                                  handlePaxDetailsChange(
                                    name,
                                    data.value,
                                    index,
                                  )
                                }
                                isClearable={false}
                                errorText={
                                  validationError &&
                                  isBookingClicked &&
                                  'Please enter gender'
                                }
                              />
                            </Col>
                          </Row>
                        ) : (
                          <Row className="spacing-8">
                            <Col lg={12}>
                              <div key={index}>
                                <div className="m-2 d-flex justify-content-between align-items-center border-bottom-2">
                                  <div className="fs-16 fw-500 p-2 align-items-center">
                                    {passenger.title === '' &&
                                    passenger.firstname === '' &&
                                    passenger.lastname === '' ? (
                                      <div className="fs-14 grey-color">
                                        Traveller {index + 1}
                                      </div>
                                    ) : (
                                      <div>
                                        {passenger.title} {passenger.firstname}{' '}
                                        {passenger.lastname}
                                      </div>
                                    )}
                                  </div>
                                  <AppIconButton
                                    onClick={() =>
                                      handleShowPaxDetails(passenger, index)
                                    }
                                    variant="transparent"
                                    className="p-2  d-flex justify-content-center align-items-center fs-14"
                                  >
                                    {passenger.title !== '' &&
                                    passenger.firstname !== '' &&
                                    passenger.lastname !== '' ? (
                                      <div className=" d-flex justify-content-center align-items-center gap-1 primary-color">
                                        <MdAccountCircle className="primary-color" />{' '}
                                        Edit
                                      </div>
                                    ) : (
                                      <div className=" d-flex justify-content-center align-items-center gap-1 primary-color">
                                        <MdAccountCircle className="primary-color" />{' '}
                                        Add
                                      </div>
                                    )}
                                  </AppIconButton>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        )}
                      </Col>
                    ))}
                  </Row>
                </div>
              </Col>
              <Col lg={3} md={3} sm={3} xs={12} className=" hide-in-mobile">
                <div className="bus-booking-review-page__body_fare-details-card">
                  <div className="bus-booking-review-page__body_fare-details-card_header d-flex justify-content-between align-items-center">
                    <span>Charges</span>
                    <AppIconButton
                      className="p-0 fs-16"
                      variant="transparent"
                      onClick={() => setShowNetFare((prev) => !prev)}
                    >
                      {showNetFare ? <IoMdEyeOff /> : <IoMdEye />}
                    </AppIconButton>
                  </div>
                  <div className="bus-booking-review-page__body_fare-details-card_body">
                    <span className="grey-color">Base Fare</span>
                    <span
                      className="fw-600 text-end hotel-results-watermarked"
                      data-watermark={`${getUserAgentId()}`}
                    >
                      {formatCurrency(fareDetails.basefare)}
                    </span>
                  </div>
                  <div className="bus-booking-review-page__body_fare-details-card_body">
                    <span className="grey-color">Taxes & other charges</span>
                    <span
                      className="fw-600 text-end hotel-results-watermarked"
                      data-watermark={`${getUserAgentId()}`}
                    >
                      {formatCurrency(fareDetails.tax || 0)}
                    </span>
                  </div>
                  <div className="bus-booking-review-page__body_fare-details-card_body">
                    <span className="grey-color">Handling Charges</span>
                    <span
                      className="fw-600 text-end hotel-results-watermarked"
                      data-watermark={`${getUserAgentId()}`}
                    >
                      {formatCurrency(fareDetails.handlingcharges || 0)}
                    </span>
                  </div>
                  <div className="bus-booking-review-page__body_fare-details-card_body">
                    <span className="grey-color">GST</span>
                    <span
                      className="fw-600 text-end hotel-results-watermarked"
                      data-watermark={`${getUserAgentId()}`}
                    >
                      {formatCurrency(fareDetails.stax || 0)}
                    </span>
                  </div>
                  {showNetFare && (
                    <>
                      <div className="bus-booking-review-page__body_fare-details-card_body">
                        <span className="grey-color">Discount</span>
                        <span
                          className="fw-600 text-end hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(fareDetails.discount || 0)}
                        </span>
                      </div>
                      <div className="bus-booking-review-page__body_fare-details-card_body">
                        <span className="grey-color">TDS</span>
                        <span
                          className="fw-600 text-end hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(fareDetails.tds)}
                        </span>
                      </div>
                      <div className="bus-booking-review-page__body_fare-details-card_body">
                        <span className="grey-color">Net Fare</span>
                        <span
                          className="fw-600 text-end hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(fareDetails.invoicetotal || 0)}
                        </span>
                      </div>
                    </>
                  )}
                  <div className="bus-booking-review-page__body_fare-details-card_body py-2 ">
                    <span className="grey-color fs-16">Total</span>
                    <span
                      className="fw-600 text-end fs-16 hotel-results-watermarked"
                      data-watermark={`${getUserAgentId()}`}
                    >
                      {addedMarkup !== ''
                        ? formatCurrency(
                            fareDetails.farequotetotal +
                              parseInt(addedMarkup, 10),
                          )
                        : formatCurrency(fareDetails.farequotetotal)}
                    </span>
                  </div>
                </div>
                <div className="seperator" />
                {getValueFromAppConfig('SHOWADDMARKUPINBOOKINGPAGE') ===
                  'show' && (
                  <div className="flight-booking-page_apply-markup mt-3 p-3 d-flex flex-column gap-2">
                    <div className="text-center fs-14 fw-600">Apply Markup</div>
                    <AppNumberInput
                      value={appliedMarkup}
                      onChange={(d) => handleAddMarkup(d)}
                      placeholderText=""
                      label="Mark up"
                    />
                    <AppButton
                      btnText={isMarkupUpdated ? 'Applied' : 'Apply'}
                      className="fs-12 white-color"
                      variant="select"
                      onClick={handleMarkupAddition}
                    />
                  </div>
                )}
              </Col>
            </Row>
            <Row className="mt-sm-4 mt-0 spacing-8">
              <Col lg={9} md={9} sm={9} xs={12} className="mt-0">
                {!isMobileWidth() ? (
                  <>
                    <div className="flight-booking-page_content">
                      <div className="fw-600 fs-18 border-bottom px-3 py-2">
                        Payment options
                      </div>
                      <div className="d-flex cursor-pointer">
                        {getEligibilityForPaymentMode('wallet') && (
                          <div
                            className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center  fw-500 ${
                              paymentMode === 'cashcard'
                                ? 'primary-color'
                                : 'grey-color'
                            }`}
                            onClick={() => setPaymentMode('cashcard')}
                          >
                            <CiWallet />
                            Wallet
                          </div>
                        )}
                        {getEligibilityForPaymentMode('creditcard') && (
                          <div
                            className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                              paymentMode === 'creditcard'
                                ? 'primary-color'
                                : 'grey-color'
                            }`}
                            onClick={() => setPaymentMode('creditcard')}
                          >
                            {' '}
                            <MdOutlineCreditCard /> CreditCard
                          </div>
                        )}
                        {getEligibilityForPaymentMode('debitcard') && (
                          <div
                            className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                              paymentMode === 'debitcard'
                                ? 'primary-color'
                                : 'grey-color'
                            }`}
                            onClick={() => setPaymentMode('debitcard')}
                          >
                            {' '}
                            <MdOutlineCreditCard /> DebitCard
                          </div>
                        )}
                        {getEligibilityForPaymentMode('netbanking') && (
                          <div
                            className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center  fw-500 ${
                              paymentMode === 'netbanking'
                                ? 'primary-color'
                                : 'grey-color'
                            }`}
                            onClick={() => setPaymentMode('netbanking')}
                          >
                            <CiBank />
                            Netbanking
                          </div>
                        )}
                        {getEligibilityForPaymentMode('upi') && (
                          <div
                            className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center  fw-500 ${
                              paymentMode === 'upi'
                                ? 'primary-color'
                                : 'grey-color'
                            }`}
                            onClick={() => setPaymentMode('upi')}
                          >
                            <CiBank />
                            UPI
                          </div>
                        )}
                      </div>
                      {paymentMode !== 'cashcard' && paymentMode !== '' && (
                        <PaymentGatewayApii
                          paymentModeClicked={paymentMode}
                          selectedPgForPaymentMode={selectedPg}
                          onPgSelect={handlePgSelect}
                        />
                      )}
                      {/* {paymentMode === 'netbanking' &&
                        (selectedPg === 'techprocessv2' ||
                          selectedPg === 'techprocessv2_netbanking') &&
                        paymentMode !== 'cashcard' &&
                        paymentMode !== '' && ( */}
                      {paymentMode === 'netbanking' && paymentMode !== '' && (
                        <div className="d-flex justify-content-start p-3">
                          <AppSelect
                            name="selected_bank"
                            id="selected_bank"
                            label="Select Bank"
                            placeholder=""
                            required
                            selectWidth="300px"
                            isClearable={false}
                            options={NET_BANKING_OPTIONS_LIVE}
                            selectedValue={selectedBankForNetBanking}
                            onSelect={(dataObj) =>
                              setSelectedBankForNetBanking(dataObj.value)
                            }
                            errorText={validationError && 'select bank'}
                          />
                        </div>
                      )}
                      {paymentMode === 'netbanking' &&
                        selectedPg === 'payu' &&
                        paymentMode !== 'cashcard' &&
                        paymentMode !== '' && (
                          <div className="d-flex justify-content-start p-3">
                            <AppSelect
                              name="selected_bank"
                              id="selected_bank"
                              label="Select Bank"
                              placeholder=""
                              required
                              selectWidth="300px"
                              isClearable={false}
                              options={PAYU_BANKING_OPTIONS_LIVE}
                              selectedValue={selectedBankForNetBanking}
                              onSelect={(dataObj) =>
                                setSelectedBankForNetBanking(dataObj.value)
                              }
                              errorText={validationError && 'select bank'}
                            />
                          </div>
                        )}
                      {paymentMode !== '' &&
                        paymentMode !== 'cashcard' &&
                        selectedPg === 'payu' && (
                          <div className="px-3 d-flex flex-column">
                            <p className="mb-2 px-4 fs-14">
                              Accept Terms and Conditions of <b>payu</b>
                            </p>
                            <AppCheckBox
                              labelText={`${agent.Company} certifies that the Credit/Debit Card/Net Banking Account being used for this transaction belongs to ${agent.Company} or an authorized employee of ${agent.Company}. In particular, this Card/Net Banking Account does not belong to a customer or passenger.`}
                              id="payuPgAccepted"
                              name="payuPgAccepted"
                              radioClassName="w-25px"
                              checked={isPayuPgAccepted}
                              labelClassName="fs-12"
                              onChange={() =>
                                setIsPayuPgAccepted((prev) => !prev)
                              }
                            />
                            <div className="d-flex align-items-center fs-12 ps-sm-4 my-2 ps-2 gap-1">
                              <img
                                src="/images/others/payu.jpg"
                                alt=""
                                height="20px"
                              />
                              <img
                                src="/images/others/visa_mastercard.gif"
                                alt=""
                                height="20px"
                              />
                              <span>
                                (Only Personal Credit Cards @ 1.77% | Rupay
                                Debit Card allowed @0.25%)
                              </span>
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="separator" />
                    <div className="flight-booking-page_content p-3 d-flex justify-content-between d-column d-md-row">
                      <AppCheckBox
                        labelText="I have reviewed and agreed to the fares and commission offered for this booking"
                        id="acceptTerms"
                        name="acceptTerms"
                        checked={acceptTerms}
                        labelClassName="fs-12"
                        onChange={() => setAcceptTerms((prev) => !prev)}
                      />
                      <div className="d-flex gap-2 align-items-center">
                        <div
                          className="fs-4 fw-600 hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {addedMarkup !== ''
                            ? formatCurrency(
                                fareDetails.farequotetotal +
                                  parseInt(addedMarkup, 10),
                              )
                            : formatCurrency(fareDetails.farequotetotal)}
                        </div>
                        {getEligibilityForPaymentMode('book') && (
                          <AppButton
                            btnText="Make payment"
                            disabled={!acceptTerms}
                            className="make-payment-btn  fs-14 px-3"
                            onClick={payNowButtonClick}
                          />
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="flight-booking-page_content">
                      <div className="flight-booking-page_header">
                        Payment options
                      </div>
                      <div className="d-flex cursor-pointer">
                        {getEligibilityForPaymentMode('wallet') && (
                          <div
                            className={`flex-1 p-2 d-flex gap-1 flex-column  fs-14 align-items-center justify-content-center fw-500 ${
                              paymentMode === 'cashcard'
                                ? 'primary-color'
                                : 'grey-color'
                            }`}
                            onClick={() => setPaymentMode('cashcard')}
                          >
                            <CiWallet className="fs-1" />{' '}
                            <span className="mt-2">Wallet</span>
                          </div>
                        )}

                        {getEligibilityForPaymentMode('creditcard') && (
                          <div
                            className={`flex-1 p-2 d-flex flex-column gap-1 fs-14 align-items-center justify-content-center fw-500 border-start ${
                              paymentMode === 'creditcard'
                                ? 'primary-color'
                                : 'grey-color'
                            }`}
                            onClick={() => setPaymentMode('creditcard')}
                          >
                            <MdOutlineCreditCard className="fs-1" />{' '}
                            <span className="mt-2">CreditCard</span>
                          </div>
                        )}
                        {getEligibilityForPaymentMode('debitcard') && (
                          <div
                            className={`flex-1 p-2 d-flex gap-1 flex-column fs-14 align-items-center justify-content-center fw-500 border-start ${
                              paymentMode === 'debitcard'
                                ? 'primary-color'
                                : 'grey-color'
                            }`}
                            onClick={() => setPaymentMode('debitcard')}
                          >
                            <MdOutlineCreditCard className="fs-1" />{' '}
                            <span className="mt-2">DebitCard</span>
                          </div>
                        )}
                        {getEligibilityForPaymentMode('netbanking') && (
                          <div
                            className={`flex-1 p-2 d-flex gap-1 fs-14 flex-column align-items-center justify-content-center fw-500 border-start ${
                              paymentMode === 'netbanking'
                                ? 'primary-color'
                                : 'grey-color'
                            }`}
                            onClick={() => setPaymentMode('netbanking')}
                          >
                            <CiBank className="fs-1" />
                            <span className="mt-2"> Netbanking</span>
                          </div>
                        )}
                        {getEligibilityForPaymentMode('upi') && (
                          <div
                            className={`flex-1 p-2 d-flex gap-1 fs-14 flex-column align-items-center justify-content-center fw-500 border-start ${
                              paymentMode === 'upi'
                                ? 'primary-color'
                                : 'grey-color'
                            }`}
                            onClick={() => setPaymentMode('upi')}
                          >
                            <CiBank className="fs-1" />
                            <span className="mt-2"> UPI</span>
                          </div>
                        )}
                      </div>

                      {paymentMode !== 'cashcard' && paymentMode !== '' && (
                        <PaymentGatewayApii
                          paymentModeClicked={paymentMode}
                          selectedPgForPaymentMode={selectedPg}
                          onPgSelect={handlePgSelect}
                        />
                      )}
                      {paymentMode === 'netbanking' && paymentMode !== '' && (
                        <div className="d-flex justify-content-start p-3">
                          <AppSelect
                            name="selected_bank"
                            id="selected_bank"
                            label="Select Bank"
                            placeholder=""
                            required
                            selectWidth="300px"
                            isClearable={false}
                            options={NET_BANKING_OPTIONS_LIVE}
                            selectedValue={selectedBankForNetBanking}
                            onSelect={(dataObj) =>
                              setSelectedBankForNetBanking(dataObj.value)
                            }
                            errorText={validationError && 'select bank'}
                          />
                        </div>
                      )}
                      {paymentMode !== '' &&
                        paymentMode !== 'cashcard' &&
                        selectedPg === 'payu' && (
                          <div className="px-3 d-flex flex-column">
                            <p className="mb-2 px-4 fs-14">
                              Accept Terms and Conditions of <b>payu</b>
                            </p>
                            <AppCheckBox
                              labelText={`${agent.Company} certifies that the Credit/Debit Card/Net Banking Account being used for this transaction belongs to ${agent.Company} or an authorized employee of ${agent.Company}. In particular, this Card/Net Banking Account does not belong to a customer or passenger.`}
                              id="payuPgAccepted"
                              name="payuPgAccepted"
                              radioClassName="w-25px"
                              checked={isPayuPgAccepted}
                              labelClassName="fs-12"
                              onChange={() =>
                                setIsPayuPgAccepted((prev) => !prev)
                              }
                            />
                            <div className="d-flex align-items-center fs-12 ps-sm-4 my-2 ps-2 gap-1">
                              <img
                                src="/images/others/payu.jpg"
                                alt=""
                                height="20px"
                              />
                              <img
                                src="/images/others/visa_mastercard.gif"
                                alt=""
                                height="20px"
                              />
                              <span>
                                (Only Personal Credit Cards @ 1.77% | Rupay
                                Debit Card allowed @0.25%)
                              </span>
                            </div>
                          </div>
                        )}
                      {paymentMode === 'netbanking' &&
                        (selectedPg === 'techprocessv2' ||
                          selectedPg === 'techprocessv2_netbanking') &&
                        paymentMode !== 'cashcard' &&
                        paymentMode !== '' && (
                          <div className="d-flex justify-content-start p-3">
                            <AppSelect
                              name="selected_bank"
                              id="selected_bank"
                              label="Select Bank"
                              placeholder=""
                              required
                              selectWidth="300px"
                              isClearable={false}
                              options={NET_BANKING_OPTIONS_LIVE}
                              selectedValue={selectedBankForNetBanking}
                              onSelect={(dataObj) =>
                                setSelectedBankForNetBanking(dataObj.value)
                              }
                            />
                          </div>
                        )}
                    </div>
                    <div className="flight-booking-page_content p-2 d-flex justify-content-between flex-column flex-sm-row gap-sm-0 gap-2">
                      <div className="d-flex align-items-center cursor-pointer pb-4">
                        <AppCheckBox
                          labelText="I have reviewed and agreed to the fares and commission offered for this booking"
                          id="acceptTerms"
                          name="acceptTerms"
                          checked={acceptTerms}
                          labelClassName="fs-12"
                          onChange={() => setAcceptTerms((prev) => !prev)}
                        />
                      </div>
                    </div>
                    <div className="bus-booking-footer d-flex  justify-content-between ">
                      <div className=" white-color">
                        <div className="fs-14 fw-500">
                          <div>Total Amount</div>
                        </div>
                        <div
                          onClick={() => setViewFareSummary(true)}
                          className="d-flex align-items-center"
                        >
                          <div
                            className="fs-4 fw-600 hotel-results-watermarked"
                            data-watermark={`${getUserAgentId()}`}
                          >
                            {addedMarkup !== ''
                              ? formatCurrency(
                                  fareDetails.farequotetotal +
                                    parseInt(addedMarkup, 10),
                                )
                              : formatCurrency(fareDetails.farequotetotal)}
                          </div>
                          <MdKeyboardArrowDown />
                        </div>
                      </div>
                      <div className="d-flex justify-content-end gap-3">
                        {getEligibilityForPaymentMode('book') && (
                          <AppButton
                            btnText="Confirm"
                            disabled={!acceptTerms}
                            className="make-payment-btn"
                            onClick={payNowButtonClick}
                          />
                        )}
                      </div>
                    </div>
                  </>
                )}
              </Col>
            </Row>
          </div>
        </>
      )}
      {showPaxModal && (
        <BusPaxBottomSheet
          show={showPaxModal}
          pax={selectedPaxRef.current}
          index={selectedPaxIndexRef.current}
          onClick={handleUpdatePaxDetails}
          onClose={() => setShowPaxModal(false)}
        />
      )}
      {showCanxPolicies && (
        <AppModal
          modalTitle="Cancellation Policy"
          showCloseButton
          showFooter={false}
          onModalClose={() => setShowCanxPolicies(false)}
          backdrop="render-backdrop"
        >
          <BusCancellationPolicy
            cancellationPolicyString={selectedBus.cancellation_policy}
          />
        </AppModal>
      )}
      {viewFareSummary && (
        <AppSidebar
          sidebarTitle={
            <div className="fw-600 d-flex justify-content-between align-items-center">
              <div>Charges</div>
              <AppIconButton
                className="p-0 fs-16"
                variant="white"
                onClick={() => setShowNetFare((prev) => !prev)}
              >
                {showNetFare ? <IoMdEyeOff /> : <IoMdEye />}
              </AppIconButton>
            </div>
          }
          onHideSidebar={() => setViewFareSummary(false)}
          animatedClass="slide-from-right-animation"
          className="app-mobile-datepicker-modal booking-review-page"
        >
          {isMobileWidth() && (
            <div className="hotel-fare-summary">
              <div className="bus-booking-review-page__body_fare-details-card_body">
                <span className="grey-color">Base Fare</span>
                <span
                  className="fw-600 text-end hotel-results-watermarked"
                  data-watermark={`${getUserAgentId()}`}
                >
                  {formatCurrency(fareDetails.basefare)}
                </span>
              </div>
              <div className="bus-booking-review-page__body_fare-details-card_body">
                <span className="grey-color">Taxes & other charges</span>
                <span
                  className="fw-600 text-end hotel-results-watermarked"
                  data-watermark={`${getUserAgentId()}`}
                >
                  {formatCurrency(fareDetails.tax || 0)}
                </span>
              </div>
              <div className="bus-booking-review-page__body_fare-details-card_body">
                <span className="grey-color">Handling Charges</span>
                <span
                  className="fw-600 text-end hotel-results-watermarked"
                  data-watermark={`${getUserAgentId()}`}
                >
                  {formatCurrency(fareDetails.handlingcharges || 0)}
                </span>
              </div>
              <div className="bus-booking-review-page__body_fare-details-card_body">
                <span className="grey-color">GST</span>
                <span
                  className="fw-600 text-end hotel-results-watermarked"
                  data-watermark={`${getUserAgentId()}`}
                >
                  {formatCurrency(fareDetails.stax || 0)}
                </span>
              </div>
              {showNetFare && (
                <>
                  <div className="bus-booking-review-page__body_fare-details-card_body">
                    <span className="grey-color">Discount</span>
                    <span
                      className="fw-600 text-end hotel-results-watermarked"
                      data-watermark={`${getUserAgentId()}`}
                    >
                      {formatCurrency(fareDetails.discount || 0)}
                    </span>
                  </div>
                  <div className="bus-booking-review-page__body_fare-details-card_body">
                    <span className="grey-color">TDS</span>
                    <span
                      className="fw-600 text-end hotel-results-watermarked"
                      data-watermark={`${getUserAgentId()}`}
                    >
                      {formatCurrency(fareDetails.tds)}
                    </span>
                  </div>
                  <div className="bus-booking-review-page__body_fare-details-card_body">
                    <span className="grey-color">Net Fare</span>
                    <span
                      className="fw-600 text-end hotel-results-watermarked"
                      data-watermark={`${getUserAgentId()}`}
                    >
                      {formatCurrency(fareDetails.invoicetotal || 0)}
                    </span>
                  </div>
                </>
              )}
              <div className="bus-booking-review-page__body_fare-details-card_body py-2 ">
                <span className="grey-color fs-16">Total</span>
                <span
                  className="fw-600 text-end fs-16 hotel-results-watermarked"
                  data-watermark={`${getUserAgentId()}`}
                >
                  {addedMarkup !== ''
                    ? formatCurrency(
                        fareDetails.farequotetotal + parseInt(addedMarkup, 10),
                      )
                    : formatCurrency(fareDetails.farequotetotal)}
                </span>
              </div>
            </div>
          )}
        </AppSidebar>
      )}
      {isBookingConfirmationDialogOpen && (
        <AppModal
          modalTitle="Booking Confirmation"
          showCloseButton
          showFooter={false}
          size="xl"
          onModalClose={() => onBookingConformationDialogClose(false)}
        >
          <section className="booking-confirmation-dialog">
            <section className="p-3 booking-confirmation-border-bottom">
              <Row className="spacing-16">
                <Col lg={12}>
                  <Row className="spacing-16">
                    <GetBookingDetailsLabel label="Journey Date" />
                    <GetBookingDetailsValue
                      value={
                        selectedBus.departuredate
                          ? formatDate(
                              getNewDate(selectedBus.departuredate),
                              DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                            )
                          : ''
                      }
                    />
                    <GetBookingDetailsLabel label="Departure Time" />
                    <GetBookingDetailsValue
                      value={
                        selectedBus.deptime
                          ? formatTimeString(selectedBus.deptime)
                          : ''
                      }
                    />
                  </Row>
                </Col>
                <Col lg={12}>
                  <Row className="spacing-16">
                    <GetBookingDetailsLabel label="Arrival date" />
                    <GetBookingDetailsValue
                      value={
                        selectedBus.arrivaldate
                          ? formatDate(
                              getNewDate(selectedBus.arrivaldate),
                              DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                            )
                          : ''
                      }
                    />
                    <GetBookingDetailsLabel label="Arrival Time" />
                    <GetBookingDetailsValue
                      value={
                        selectedBus.arrtime
                          ? formatTimeString(selectedBus.arrtime)
                          : ''
                      }
                    />
                  </Row>
                </Col>
                <Col lg={12}>
                  <Row className="spacing-16">
                    <GetBookingDetailsLabel label="Bus" />
                    <GetBookingDetailsValue value={selectedBus.operatorname} />
                    <GetBookingDetailsLabel label="Bus Type" />
                    <GetBookingDetailsValue value={selectedBus.bustype} />
                  </Row>
                </Col>
                <Col lg={12}>
                  <Row className="spacing-16">
                    <GetBookingDetailsLabel label="From" />
                    <GetBookingDetailsValue value={boardingPoint.name} />
                    <GetBookingDetailsLabel label="To" />
                    <GetBookingDetailsValue value={droppingPoint.name} />
                  </Row>
                </Col>
                <Col lg={12}>
                  <Row className="spacing-16">
                    <GetBookingDetailsLabel label="Duration" />
                    <GetBookingDetailsValue
                      value={convertTravelTime(selectedBus.duration)}
                    />
                    <GetBookingDetailsLabel label=" No. Of Passenger" />
                    <GetBookingDetailsValue value={passengers.length} />
                  </Row>
                </Col>
                <Col lg={12}>
                  <Row className="spacing-16">
                    <GetBookingDetailsLabel label="Email" />
                    <GetBookingDetailsValue value={contactDetails.email} />
                    <GetBookingDetailsLabel label="Mobile" />
                    <GetBookingDetailsValue
                      value={contactDetails.phoneNumber}
                    />
                  </Row>
                </Col>
              </Row>
            </section>
            <section className="p-3 booking-confirmation-border-bottom">
              <div className="pb-1">
                <span className="booking-dialog-header">Passenger Details</span>
              </div>
              <Table className="booking-confirmation-pax-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Gender</th>
                    <th>Age</th>
                    <th>Seat No.</th>
                  </tr>
                </thead>
                <tbody>
                  {passengers.map((d) => (
                    <tr key={d.seatnumber}>
                      <td>{getFullName(d)}</td>
                      <td>{d.gender}</td>
                      <td>{d.age}</td>
                      <td>{d.seatnumber}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </section>
            <section className="p-3 booking-confirmation-border-bottom">
              <div className="pb-2">
                <span className="booking-dialog-header">Fare Breakup</span>
              </div>
              <Row className="spacing-16">
                <Col lg={12}>
                  <Row className="spacing-16">
                    <GetBookingDetailsLabel label="Base Fare" />
                    <GetBookingDetailsValue
                      value={
                        <span
                          className="hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(fareDetails.basefare)}
                        </span>
                      }
                    />
                  </Row>
                </Col>
                <Col lg={12}>
                  <Row className="spacing-16">
                    <GetBookingDetailsLabel label="Taxes & other charges" />
                    <GetBookingDetailsValue
                      value={
                        <span
                          className="hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(fareDetails.tax || 0)}
                        </span>
                      }
                    />
                  </Row>
                </Col>
                <Col lg={12}>
                  <Row className="spacing-16">
                    <GetBookingDetailsLabel label="Handling Charges" />
                    <GetBookingDetailsValue
                      value={
                        <span
                          className="hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(fareDetails.handlingcharges || 0)}
                        </span>
                      }
                    />
                  </Row>
                </Col>
                <Col lg={12}>
                  <Row className="spacing-16">
                    <GetBookingDetailsLabel label="GST" />
                    <GetBookingDetailsValue
                      value={
                        <span
                          className="hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(fareDetails.stax || 0)}
                        </span>
                      }
                    />
                  </Row>
                </Col>
                <Col lg={12}>
                  <Row className="spacing-16">
                    <GetBookingDetailsLabel label="Discount (-)" />
                    <GetBookingDetailsValue
                      value={
                        <span
                          className="hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(fareDetails.discount || 0)}
                        </span>
                      }
                    />
                  </Row>
                </Col>
                <Col lg={12}>
                  <Row className="spacing-16">
                    <GetBookingDetailsLabel label="TDS" />
                    <GetBookingDetailsValue
                      value={
                        <span
                          className="hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(fareDetails.tds)}
                        </span>
                      }
                    />
                  </Row>
                </Col>
                <Col lg={12}>
                  <Row className="spacing-16">
                    <GetBookingDetailsLabel label="Net Fare" />
                    <GetBookingDetailsValue
                      value={
                        <span
                          className="hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(fareDetails.invoicetotal || 0)}
                        </span>
                      }
                    />
                  </Row>
                </Col>
                <Col lg={12}>
                  <Row className="spacing-16">
                    <Col lg={2} md={4} sm={4} xs={4}>
                      <span className="booking-details-value error-text">
                        Total
                      </span>
                    </Col>
                    <Col lg={4} md={8} sm={8} xs={8}>
                      <span
                        className="booking-details-value error-text hotel-results-watermarked"
                        data-watermark={`${getUserAgentId()}`}
                      >
                        {addedMarkup !== ''
                          ? formatCurrency(
                              fareDetails.farequotetotal +
                                parseInt(addedMarkup, 10),
                            )
                          : formatCurrency(fareDetails.farequotetotal)}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col lg={12}>
                  <Row className="spacing-16">
                    <GetBookingDetailsLabel label=" Payment Surcharge" />
                    <GetBookingDetailsValue
                      value={
                        <span
                          className="hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(checkoutPgCharge || 0)}
                        </span>
                      }
                    />
                  </Row>
                </Col>
                <Col lg={12}>
                  <Row className="spacing-16">
                    <GetBookingDetailsLabel label=" GST on Payment Surcharge" />
                    <GetBookingDetailsValue
                      value={
                        <span
                          className="hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(checkoutgstPgCharge || 0)}
                        </span>
                      }
                    />
                  </Row>
                </Col>
                <Col lg={12}>
                  <Row className="spacing-16">
                    <Col lg={2} md={4} sm={4} xs={4}>
                      <span className="booking-details-value error-text">
                        You Pay
                      </span>
                    </Col>
                    <Col lg={4} md={8} sm={8} xs={8}>
                      <span
                        className="booking-details-value error-text hotel-results-watermarked"
                        data-watermark={`${getUserAgentId()}`}
                      >
                        {formatCurrency(checkoutInvTotal)}
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </section>
            <section
              className="d-flex justify-content-center p-3"
              style={{ paddingTop: 32 }}
            >
              <AppButton
                variant="primary"
                btnText="Book"
                onClick={() => onBookingConformationDialogClose(true)}
                className="width-150"
              />
              <AppButton
                variant="outlined"
                btnText="Close"
                onClick={() => onBookingConformationDialogClose(false)}
                className="width-150 ms-3"
              />
            </section>
          </section>
        </AppModal>
      )}
      <Modal
        backdrop="static"
        keyboard={false}
        size="lg"
        className="app-modal"
        show={showPassengerSearchModal}
        onHide={onCancelSelectCustomer}
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg={6}>
              <AppTextInput
                name="searchText"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </Col>
            <Col lg={6}>
              <AppButton onClick={handleSearchCustomer} btnText="Search" />
            </Col>
          </Row>
          {customers.length > 0 && (
            <div className="overflow-auto">
              <table className="table table-bordered fs-14 mt-2">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>PaxName</th>
                    <th>Mobile</th>
                    <th>Age</th>
                    <th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <input
                        checked={
                          selectedCustomers.findIndex(
                            (x) => x.ProfileId === customers[0].ProfileId,
                          ) > -1
                        }
                        onChange={() => handleCustomerSelect(customers[0])}
                        type="checkbox"
                      />
                    </td>
                    <td>{`${customers[0].FirstName} ${customers[0].LastName}`}</td>
                    <td>{customers[0].Phone}</td>
                    <td>{customers[0].Age}</td>
                    <td>{customers[0].Email}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <AppButton
            variant="secondary"
            onClick={onCancelSelectCustomer}
            btnText="Cancel"
          />
          <AppButton
            variant="primary"
            onClick={handleSelectCustomer}
            btnText="Submit"
          />
        </Modal.Footer>
      </Modal>
      {}
    </section>
  );
}

BusBookingReview.defaultProps = {};

BusBookingReview.propTypes = {};

export default BusBookingReview;
